module.exports = __webpack_public_path__ + "static/media/bg_minigame_whale.2ec30403.png";